import { TEXT } from '../../shared/languages';

export const Loading = ({ label = TEXT.messages.loadingData }) => (
  <div className="state-card">
    <div className="spinner" />
    <p>{label}</p>
    <div className="skeleton-stack" aria-hidden="true">
      <span className="skeleton title" />
      <span className="skeleton text" />
      <span className="skeleton text short" />
    </div>
  </div>
);
